<template>
    <div class="idxRequest">
        <form class="contact" :class="{hidden: view === VIEWS.success}">
            <h1>Contact the Davis Agency</h1>
            <div class="field">
                <label for="name" v-text="'Name *'" />
                <input id="name" v-model="contact.name">
            </div>
            <div class="field">
                <label for="email" v-text="'Email *'" />
                <input id="email" v-model="contact.email">
            </div>
            <div class="field">
                <label for="phone" v-text="'Phone'" />
                <input id="phone" v-model="contact.phone">
            </div>
            <div class="field">
                <label for="message" v-text="'Message'" />
                <textarea id="message" v-model="contact.message" />
            </div>
            <div class="field">
                <label v-html="'&nbsp;'" />
                <button @click.prevent="submitContact" v-text="sending ? 'Sending...' : 'Send'" :disabled="!formValid || sending" />
            </div>
            <p class="error" v-if="view === VIEWS.error">
                There was a problem sending your message. Please try again later or call our office.
            </p>
        </form>

        <div class="success" v-if="view === VIEWS.success">
            <h1>Success!</h1>
            <p>We have sent your request to Davis Agency, and one of our agents will contact you soon.</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
let isEmail = require('isemail');

axios.defaults.baseURL = process.env.MIX_API_BASE_URL;

export default {
    props: {
        listingId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            contact: {
                name: '',
                email: '',
                phone: '',
                message: 'I would like more information about this property.',
            },
            view: 1,
            sending: false,
        };
    },
    computed: {
        formValid() {
            // return this.contact.name.trim() && addrs.parseOneAddress(this.contact.email);
            return this.contact.name.trim() && isEmail.validate(this.contact.email, {minDomainAtoms: 2});
        },
    },
    methods: {
        submitContact() {
            let vue = this;
            let data = {
                listingId: vue.listingId,
                contact: vue.contact,
            };
            vue.sending = true;
            axios.post('/api/idx-requests', data)
                .then(response => {
                    vue.view = this.VIEWS.success;
                })
                .catch(error => {
                    console.error(error);
                    axios.post('/api/logs', {message: 'Problem sending IDX request.'});
                    axios.post('/api/logs', {data});
                    vue.view = this.VIEWS.error;
                })
                .finally(() => {
                    vue.sending = false;
                })
            ;
        },
    },
    created() {
        this.VIEWS = {
            form: 1,
            success: 2,
            error: 3,
        };
        this.view = this.VIEWS.form;
    },
}
</script>

<style lang="scss">
.idxRequest {
    padding: 10px;
    margin: 10px 0 0 0;
    background-color: #bbbbff;
    position: relative;

    button {
        font-size: 10pt;
        cursor: pointer;
        line-height: 0;
        border-style: solid;
        height: 0;
        border-radius: 24px;
        border-width: 12px;
        border-color: #101030;
        background-color: #101030;
        color: white !important;
        margin: 0 5px;
    }

    h1 {
        padding: 5px 0 15px 0;
        margin: 0;
        font-size: 28pt;
    }

    .field {
        margin-bottom: 5px;
    }

    label {
        display: inline-block;
        width: 6em;
        vertical-align: top;
    }

    input, textarea, .error {
        width: calc(100% - 8em);
        max-width: 25em;
        padding: 2px;
        font-size: 12pt;
    }

    textarea {
        height: 8em;
    }

    button[disabled] {
        color: gray !important;
        opacity: 0.5;
    }

    form {
        &.hidden {
            visibility: hidden;
        }
    }

    .success {
        position: absolute;
        top: 10px;

        p {
            font-size: 150%;
            line-height: 1.4;
        }
    }

    .error {
        margin-left: 6.4em;
        color: #bb0032 !important;
    }
}
</style>
